import React, { Component } from 'react';
import { Modal, Button, Tabs, Table } from 'antd';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import ExportUtil from '../../../../common/ExportUtil';
import TableC from '../../../basicElement/TableC';
import { tableColumns, tabs } from '../pageMes';


const TabPane = Tabs.TabPane;
const MinusTabs = tabs.slice(5,10)
class MinusScoreDetail extends Component {

    state = {
        visible: false,
        data:[],
        record:{},
        pagination: {
            current: 1,
            pageSize: 5,
        },
        activeKey:'6',
        menuType:tableColumns['6'].menuType ,
    }

    show = record => {
        this.setState({ visible: true, record }, this.loadData)
    }

    loadData = () =>{
        const { pagination:{ current, pageSize }, menuType, record:{ userId, year, month }, pagination } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.user.queryPositionCrcDetailList,
            data: {
                limit:pageSize,
                menuType,
                userId,
                offset: current,
                isRecord:1,
                recordYear:year,
                recordMonth:month,
            },
            dataType: 'json',
            doneResult: res => {
                pagination.total = res.totalCount;
                this.setState({
                    loading: false,
                    data: res.datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    getColumns = () => {
        const { activeKey } = this.state
        const columns = [{
            title: '序号',
            dataIndex: 'indexNum',
            key: 'indexNum',
            width: 80,
        },{
            title: '时间',
            dataIndex: 'date',
            key: 'date',
            width: tableColumns[activeKey].timeWidth || 120,
            render: (text, record) => {
                const { date, beginYearMonth, endYearMonth } = record;
                return date ? date.slice(0,10) : `${beginYearMonth}~${endYearMonth}`
            }
        }]
        columns.push( ...tableColumns[activeKey].childTable)
        return columns
    }
    
    handleCancel = () => {
        this.setState({
            visible: false,
            data:[],
            record:{},
            pagination: {
                current: 1,
                pageSize: 5,
            },
            activeKey:'6',
            menuType:tableColumns['6'].menuType ,
        })
    }

    export = () => {
        const { record:{ userId, year, month }, menuType } = this.state;
        ExportUtil.export({ userId, recordYear:year, recordMonth:month, isAdd:0, menuType }, null, API_URL.user.exportCrcPostRecord);
    }

    handleTableChange = params => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    handleTabClick = activeKey => {
        this.setState({ 
            activeKey, 
            menuType: activeKey === '1' ? null: tableColumns[activeKey].menuType,
            pagination: {
                current: 1,
                pageSize: 5,
                total:1
            }
        },this.loadData);
    }

    getData = data => {
        const { pagination:{ current, pageSize } } = this.state;
        data.forEach((el, index) => {
            el.indexNum = index + 1 + (current - 1) * pageSize;
        })
        return data
    }

    render () {
        const { visible, data, pagination, activeKey, record } = this.state;
        return(
            <Modal
                title="减分明细"
                visible={visible}
                width={800}
                onCancel={this.handleCancel}
                footer={<Button onClick={this.handleCancel}>关闭</Button>}
                >
                    <div style={{ padding:'0 20px 20px 20px' }}>
                    <span>{`时间：${record.recordYearMonth}`}</span>
                        <Button style={{ float:'right' }} type="primary" onClick={this.export}>导出</Button>
                    </div>
                    <Tabs type="card" activeKey={activeKey} onChange={this.handleTabClick}>
                        {MinusTabs.map(pane => <TabPane tab={pane.tab} key={pane.key}></TabPane>)}
                    </Tabs>
                    <TableC
                        data={this.getData(data)}
                        pagination={pagination}
                        columns={this.getColumns()}
                        onChange={this.handleTableChange}
                    />
            </Modal>
        )
    }
}

export default MinusScoreDetail


// WEBPACK FOOTER //
// ./src/components/user/crcPostRank/components/MinusScoreDetail.js